// src/layout/responsive.ts
function getResponsiveProps(variable, inputValues, valueTransformer = (value) => String(value)) {
  if (!inputValues) return {};
  if (typeof inputValues !== "object") {
    return { [`${variable}-initial`]: valueTransformer(inputValues) };
  }
  const result = {};
  for (const [key, value] of Object.entries(inputValues)) {
    result[`${variable}-${key}`] = valueTransformer(value);
  }
  return result;
}

export {
  getResponsiveProps
};
//# sourceMappingURL=chunk-7ROE6ADK.mjs.map